import type { NotificationRenderer } from "./types";
import { NotificationMetadataCard } from "../NotificationMetadataCard";
import { BodyCard } from "./BodyCard";

export const GenericRenderer: NotificationRenderer = {
  render: (notification) => (
    <>
      <BodyCard body={notification.body} delay={0.1} />
      {Object.keys(notification.metadata ?? {}).length > 0 && (
        <NotificationMetadataCard metadata={notification.metadata} />
      )}
    </>
  ),
};
